module.exports = __webpack_public_path__ + "static/media/add-music.0f6656eb.svg";